import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

// Memoized presentational component for section cards
const SectionCard = ({
  icon,
  iconColor,
  title,
  link,
  children,
  emptyMessage,
}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white dark:bg-dark-surface bg-gradient-to-b from-white to-gray-50 dark:from-dark-surface dark:to-primary-800 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 p-3 relative border border-gray-100 dark:border-gray-700">
      <Link
        to={link}
        className="absolute top-2 right-2.5 text-[10px] text-primary-400 dark:text-primary-300 hover:text-primary-600 dark:hover:text-primary-100 transition-colors duration-200"
      >
        {t("common.more")}
      </Link>
      <h2 className="text-lg font-bold flex items-center mb-3 text-primary-700 dark:text-primary-100">
        <FontAwesomeIcon icon={icon} className={`mr-2 ${iconColor}`} />
        {title}
      </h2>
      <div className="space-y-3">
        {children}
        {React.Children.count(children) === 0 && (
          <p className="text-gray-500 dark:text-gray-400">{emptyMessage}</p>
        )}
      </div>
    </div>
  );
};

export default React.memo(SectionCard);
